function parseCellKey(key) {
  const idx = String(key).indexOf(':');
  if (idx === -1) return null;
  const r = Number(String(key).slice(0, idx));
  const c = Number(String(key).slice(idx + 1));
  if (!Number.isInteger(r) || !Number.isInteger(c) || r < 0 || c < 0) return null;
  return [r, c];
}

function cellInput(cell) {
  if (!cell) return '';
  if (cell.f !== undefined) return `=${cell.f}`;
  if (cell.v === null || cell.v === undefined) return '';
  if (typeof cell.v === 'boolean') return cell.v ? 'TRUE' : 'FALSE';
  return String(cell.v);
}

export function csvEscape(value) {
  const text = value == null ? '' : String(value);
  if (/[",\r\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function workbookModelToCsv(model, sheetIndex = 0) {
  const sheet = model && Array.isArray(model.sheets) ? model.sheets[sheetIndex] : null;
  if (!sheet || !sheet.cells || typeof sheet.cells !== 'object') return '';

  let maxR = -1;
  let maxC = -1;
  for (const key of Object.keys(sheet.cells)) {
    const parsed = parseCellKey(key);
    if (!parsed) continue;
    maxR = Math.max(maxR, parsed[0]);
    maxC = Math.max(maxC, parsed[1]);
  }
  if (maxR < 0 || maxC < 0) return '';

  const lines = [];
  for (let r = 0; r <= maxR; r += 1) {
    const row = [];
    for (let c = 0; c <= maxC; c += 1) {
      row.push(csvEscape(cellInput(sheet.cells[`${r}:${c}`])));
    }
    lines.push(row.join(','));
  }
  return lines.join('\n');
}

export function parseCsvRows(text, delimiter = ',') {
  const rows = [];
  let row = [];
  let field = '';
  let inQuotes = false;
  const src = String(text || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');

  for (let i = 0; i < src.length; i += 1) {
    const ch = src[i];
    if (inQuotes) {
      if (ch === '"') {
        if (src[i + 1] === '"') {
          field += '"';
          i += 1;
        } else {
          inQuotes = false;
        }
      } else {
        field += ch;
      }
      continue;
    }

    if (ch === '"') {
      inQuotes = true;
    } else if (ch === delimiter) {
      row.push(field);
      field = '';
    } else if (ch === '\n') {
      row.push(field);
      rows.push(row);
      row = [];
      field = '';
    } else {
      field += ch;
    }
  }

  row.push(field);
  if (row.length > 1 || row[0] !== '' || src.endsWith(delimiter)) rows.push(row);
  return rows;
}
